import {createColumnHelper} from '@tanstack/react-table'
import {optionsTakNie} from "../../../../utils/options.js";

const columnHelper = createColumnHelper()

export const listaosobColumns = [
    columnHelper.accessor('id', {
            header: 'ID',
            enableColumnFilter: false,
        },
    ),
    {accessorFn: (row) => row.imie + ' ' + row.nazwisko, header: 'Imię i nazwisko'},
    {accessorFn: (row) => row.email, header: 'Email'},
    {accessorFn: (row) => row.name, header: 'Nazwa użytkownika'},
    {
        accessorFn: (row) => row.czy_manager, header: 'Czy kierownik/koordynator',
        meta: {
            filterVariant: 'select',
            options: optionsTakNie,

        }
    },

    {accessorFn: (row) => row.slownik_unit_id, header: 'Departament'},
    {accessorFn: (row) => row.slownik_team_id, header: 'Team / Referat / Zespół (jeśli podlega pod dyrektora)'},
    {accessorFn: (row) => row.slownik_subteam_id, header: 'Zespół / Podreferat'},
    {
        accessorFn: (row) => row.perms.map((u) => u).join(', '),
        header: 'Uprawnienia'
    },
]